module.exports = __webpack_public_path__ + "static/media/feature-tile-icon-06.8bba1d64.svg";